import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import { AuthContext } from '../../../../context';

import { nav, link, active } from './secondary-nav.module.scss';

function SecondaryMobileNav() {
  const { currentUser } = useContext(AuthContext);

  return (
    <nav className={`row ${nav}`}>
      {
        currentUser && (
          <>
            <NavLink to="/home" activeClassName={active} className={`col-3 ${link}`}>
              Home
            </NavLink>
            <NavLink to="/answer" className={`col-3 ${link}`}>
              Answer
            </NavLink>
            <NavLink to="/notifications" className={`col-3 ${link}`}>
              Notifs
            </NavLink>
            <NavLink 
            to={{
              pathname: `/account/${currentUser.fullname}`,
              state: {
                userId: currentUser.id
              }
            }} 
            className={`col-3 ${link}`}
            >
              You
            </NavLink>
          </>
        )
      }
    </nav>
  );
}

export default SecondaryMobileNav;
